'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

module.exports = function contains(other) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument is required');
  }

  if (_typeof(other) !== 'object') {
    throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
  }

  var node = other;

  do {
    if (this === node) {
      return true;
    }

    if (node) {
      node = node.parentNode;
    }
  } while (node);

  return false;
};